<template>
    <div>
        <v-card>
            <v-card-text>
                <ul class="list-info">
                    <li><b>{{ data.fullname }}</b></li>
                    <li><b>{{ data.propagandist }}</b></li>
                    <li>
                        <v-btn
                            x-small
                            @click="showOtherInfo()"
                        >
                            {{ $t('fields.other_info') }}
                        </v-btn>
                    </li>
                </ul>
            </v-card-text>
            <v-card-actions>
                <BtnAddEditSchool
                    class="primary"
                    :id="id"
                    @actionend="fetchSchool(id)"
                    :return-url="`${$router.currentRoute.path}?id=${data.id}`"
                >
                    {{ $t('EDIT') }}
                </BtnAddEditSchool>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import SchoolAdditionalInfoModal from '../../modals/Schools/SchoolAdditionalInfoModal.vue';
import BtnAddEditSchool from '../../buttonsForms/BtnAddEditSchool.vue';

export default {
    name: 'SchoolCommonInfo',
    components: { BtnAddEditSchool },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        id: {
            type: [String, Number],
        },
    },
    methods: {
        ...mapActions('modal', ['showModal', 'hideModal']),
        showOtherInfo() {
            this.showModal({
                component: SchoolAdditionalInfoModal,
                    data: {
                    stored: {
                        id: this.id,
                    },
                },
                options: {
                    title: this.$t('SCHOOL'),
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
    .list-info {
        display: flex;
        li {
            /*display: inline;*/
            list-style-type: none;
            padding-left: 10px;
        }
    }
</style>
